const OthersActionTypes = {
	UPDATE_TRAVEL_REASONS: 'UPDATE_TRAVEL_REASONS',
}

export default OthersActionTypes
